import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { STORERANK_METRICS_OPTIONS_LIST } from '@/pages/intelligence/_config/storeRank/config';
import { pipe } from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setDateTitle,
  setNewTitleByCompanyShow,
  setTitleByGenreShow,
  setTitleByRegionShow,
  setTitleByReleaseDateShow,
  setTitleBySteamIdShow,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';

interface IParams {
  source_type?: any[];
  downloadType?: 'avg' | 'latest' | 'trend';
  key?: any;
  current_tab?: string;
}
interface TitleType {
  title: string;
  key: string;
}
const sourceTypeMap = {
  steam: 'steam',
  epic: 'epic',
  play_station: 'playstation',
  xbox: 'xbox',
  nintendo: 'nintendo',
};

const columnsTable = [
  {
    key: 'rank_1_3',
    title: '1-3',
  },
  {
    key: 'rank_1_3_dod',
    title: 'Change',
  },
  {
    key: 'rank_4_10',
    title: '4-10',
  },
  {
    key: 'rank_4_10_dod',
    title: 'Change',
  },
  {
    key: 'rank_11_50',
    title: '11-50',
  },
  {
    key: 'rank_11_50_dod',
    title: 'Change',
  },
  {
    key: 'rank_51_200',
    title: '50-200',
  },
  {
    key: 'rank_51_200_dod',
    title: 'Change',
  },
];
const getSummarySheet = (params: Record<string, any>) => {
  const list: any[] = [
    ['Regions/Countries', params?.regions.join(',')],
    ['Date Start', params?.start_date],
    ['Date End', params?.end_date],
    ['Game Name', params?.name],
  ];
  return list;
};

const getSourceName = (params: any) => {
  const { source = [] } = params || {};
  if (Array.isArray(source) && source?.length > 0) {
    return (
      STORERANK_METRICS_OPTIONS_LIST.find((item: any) => item.value === source[0]).downloadTitle ||
      ''
    );
  }
};

const getColumn = (params: any, isTable = false) => {
  const list: TitleType[] = [];
  // const { source = [], current_tab = 'avg' }: IParams = params || {};
  const pipeFront = pipe(
    setDateTitle(isTable),
    setNewTitleByCompanyShow(params.company_show),
    setTitleByGenreShow(params.genre_show),
    setTitleByReleaseDateShow(params.release_date_show),
    setTitleByRegionShow(params.region_show),
    setTitleBySteamIdShow(params.steam_id_show),
  );
  pipeFront(list);
  // eslint-disable-next-line @typescript-eslint/naming-convention

  // const filterSourceType = source_type
  //   .filter((item) => item !== undefined)
  //   .map((ele) => {
  //     return sourceTypeMap[ele as keyof typeof sourceTypeMap];
  //   });
  // const filterData = STORERANK_METRICS_OPTIONS_LIST.find((item: any) => item.value === source[0]);
  // filterData.forEach((ele) => {
  list.push(...columnsTable);
  // });
  return list;
};

export default (params: Record<string, any>) => {
  // console.log('paramsparamsfwefwewf', params);
  return {
    ...commonSetting,
    // $$fileName: `${params?.new_style_donwload_file_name}(6) Store Rank_${params?.start_date}_${params?.end_date}`,
    $$fileName: `${params?.new_style_donwload_file_name}_${getSourceName(params)} Market Count_${
      params?.start_date
    }_${params?.end_date}`,
    dataKey: ['market_count'],
    fetchOnlyOnce: true,
    fParams: {
      unified_id: '',
      app_ids: params?.app_ids,
      entity_type: params?.entity_type,
      source: params?.source,
      region_type: 'market',
      regions: params?.regions,
      granularity: params?.granularity,
      start_date: params?.start_date,
      end_date: params?.end_date,
      order_source: params?.order_source,
      order: params?.order,
      b_last_date: false,
      b_ratio_start_date: false,
      ext_fields: {
        basic_info: {
          combined_id: params?.combine_id,
        },
        market_count: {},
      },
      trend_regions: [],
    },
    downloadFetchApi: '/api/v1/intelligence_pc/storeRank/pc_console',
    needBasicInfo: true,
    summarySheet: getSummarySheet(params),
    sheetName: ['Market Count'],
    // 'Market Count': columnsTable,
    'Market Count': getColumn(params),
  };
};
